import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Map } from 'immutable';
import DropDownButton from '../../ui/DropDownButton';
import { ModalActions } from '../../../actions/modal';
import { AccountActions } from '../../../actions/account';
import {
  SUPER_USER,
  ORGROLE_ADMIN,
  ACCTROLE_ADMIN,
} from '../../../shared/constants';

import faBars from '@fortawesome/fontawesome-pro-light/faBars';

@withRouter
export default class ContextMenu extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    accountId: PropTypes.number,
    currentUser: PropTypes.instanceOf(Map),
  };

  isAdmin = () => {
    const { account, currentUser } = this.props;
    const accountId = account.get('id');
    const accountsOrg = account.get('organization_id');
    const orgRole = currentUser && currentUser.getIn(
      ['roles', 'organization', accountsOrg],
      null,
    );
    const accRole = currentUser && currentUser.getIn(['roles', 'account', accountId], null);

    if (
      currentUser.get('role_id') === SUPER_USER ||
      orgRole === SUPER_USER ||
      orgRole === ORGROLE_ADMIN ||
      accRole === SUPER_USER ||
      accRole === ACCTROLE_ADMIN
    ) {
      return true;
    }

    return false;
  };

  canUserDelete = () => {
    const { account } = this.props;
    const projectsCount = parseInt(
      account.getIn(['counts', 'projects'], 0),
      10,
    );
    const isAdmin = this.isAdmin();
    if (isAdmin && projectsCount === 0) {
      return true;
    }

    return false;
  };

  confirmDelete = () => {
    const { dispatch, account } = this.props;
    const name = account.get('name');

    dispatch(
      ModalActions.toggleModal({
        name: 'DeleteConfirmationModal',
        options: {
          deleteType: 'account',
          handleDelete: this.deleteAccount,
          name,
        },
      }),
    );
  };

  deleteAccount = () => {
    const { dispatch, account, currentUser } = this.props;
    const accountId = account.get('id');
    const userId = currentUser.get('id');
    // console.log('deleting acc', accountId);
    dispatch(AccountActions.deleteAccount(accountId, userId));
  };

  toggleRenameModal = () => {
    const { dispatch, account } = this.props;

    dispatch(
      ModalActions.toggleModal({
        name: 'RenameAccountModal',
        options: {
          accountName: account.get('name'),
          currentAccountId: account.get('id'),
        },
      }),
    );
  }

  render() {
    const { account, router } = this.props;
    const accountId = account.get('id');
    const isAdmin = this.isAdmin();
    const hasDeleteAccess = this.canUserDelete();

    const deleteItem = hasDeleteAccess
      ? <a onClick={this.confirmDelete} className="dropdown-item">
          Delete
        </a>
      : <span className="dropdown-item text-muted">
          Delete <i className="fa fa-exclamation-triangle" aria-hidden="true" />
        </span>;

    const renameItem = (<a onClick={this.toggleRenameModal} className="dropdown-item">
      Rename
    </a>);

    const link = `/accounts/${accountId}`;

    return (
      <DropDownButton
        title=""
        icon={faBars}
        mouseLeave
        hideToggle
        isHoverButton
        styleOverrides={{
          background: '#f5f5f5',
        }}
        style={{
          marginTop: 5,
          marginBottom: 5,
          marginRight: 5,
          float: 'right',
          zIndex: 3000,
        }}
      >
        <a onClick={() => router.push(link)} className="dropdown-item">
          View
        </a>
        {deleteItem}
        {isAdmin && renameItem}
      </DropDownButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/contextMenus/accountContext.js